"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactScroll = require("react-scroll");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../constants");
var _helpers = require("../../helpers");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CategoryPhotos = function CategoryPhotos(_ref) {
  var children = _ref.children,
    id = _ref.id,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    name = _ref.name,
    onIntersection = _ref.onIntersection;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
    t = _useTranslation.t;
  var categoryBlockRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var root = global.document.getElementById(_constants.CATEGORIES_PHOTOS_BLOCK_ID);
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        isIntersecting = _ref3[0].isIntersecting;
      if (isIntersecting) {
        onIntersection();
      }
    }, {
      root: root,
      rootMargin: "0px 0px -".concat(root.offsetHeight, "px 0px"),
      threshold: 0
    });
    observer.observe(categoryBlockRef.current.childBindings.domNode);
    if (isLast || isFirst) {
      var scrollHandler = function scrollHandler() {
        var isEnd = isLast && root.offsetHeight + root.scrollTop >= root.scrollHeight;
        var isStart = isFirst && root.scrollTop <= 1;
        var shouldHandleIntersection = isEnd || isStart;
        if (shouldHandleIntersection) {
          onIntersection();
        }
      };
      root.addEventListener('scroll', scrollHandler);
      return function () {
        return observer.disconnect(), root.removeEventListener('scroll', scrollHandler);
      };
    }
    return function () {
      return observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactScroll.Element, {
    className: _styles.default.categoryBlock,
    id: (0, _helpers.generateCategoryPhotosBlockID)(id),
    ref: categoryBlockRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.categorySidebar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.categorySidebarName
  }, id === _constants.WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME.id ? t('GALLERY_PHOTOS_EMPTY_CATEGORY_LABEL') : name)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.categoryPhotos
  }, children));
};
CategoryPhotos.propTypes = {
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired,
  onIntersection: _propTypes.default.func.isRequired,
  children: _propTypes.default.any,
  isFirst: _propTypes.default.bool,
  isLast: _propTypes.default.bool
};
var _default = exports.default = (0, _react.memo)(CategoryPhotos);